// extracted by mini-css-extract-plugin
module.exports = {"header":"GWzNt","logo":"AKaMw","nav-item":"JVEY1","text":"e3Fy9","buttonContainer":"fn4Iz"};